document.addEventListener("alpine:init", () => {
    Alpine.data("contactForm", () => ({
        selectfields: null,
        sendingContainer: null,
        success: false,
        form: null,
        confirmationPage: null,
        redirectToConfirmationPage: false,
        secondConfirmationPage: null,
        downloadLink: null,
        showFirst: true,

        init() {
            this.form = this.$el.querySelector("form.wpcf7-form");
            this.sendingContainer = this.$el.querySelector(".form__sending");

            this.$el.querySelectorAll(".wpcf7-submit").forEach((button) => {
                button.addEventListener("click", () => {
                    this.sendingContainer.classList.remove("hidden");
                    this.sendingContainer.classList.add("flex");
                });
            });

            this.$el.querySelector(".wpcf7").addEventListener(
                "wpcf7invalid",
                (e) => {
                    this.sendingContainer.classList.add("hidden");
                    this.sendingContainer.classList.remove("flex");
                },
                false
            );

            this.confirmationPage = this.$el.dataset.confirmationPage;
            this.secondConfirmationPage = this.$el.dataset.secondConfirmationPage;

            this.redirectToConfirmationPage = this.$el.dataset.redirectToConfirmationPage === '1';

            this.form.addEventListener("wpcf7mailsent", (event) => {
                if (this.redirectToConfirmationPage && this.confirmationPage) {
                    window.location.href = this.confirmationPage;
                } else {
                    this.fetchConfirmation();
                }
            });

            this.downloadLink = this.$el.dataset.downloadLink;
        },

        fetchConfirmation() {
            // Check which form is being shown
            const confirmationPage = this.showFirst ? this.confirmationPage : this.secondConfirmationPage;

            if (!confirmationPage) {
                // If confirmationPage is empty, do nothing
                this.success = true;

                if (this.downloadLink) {
                    window.open(this.downloadLink);
                }
                return;
            }
        
            const mainContainer = this.$el.querySelector(".main-container");
            fetch(this.confirmationPage)
                .then((response) => response.text())
                .then((html) => {
                    const parser = new DOMParser(),
                        doc = parser.parseFromString(html, "text/html");
        
                    const replace = doc.querySelector("main article");
                    mainContainer.innerHTML = replace.innerHTML;
                    this.success = true;
        
                    if (this.downloadLink) {
                        window.open(this.downloadLink);
                    }
                });
        }
        
    }));
});

